    <div class="container" style="margin-top: 20px;">
        <div [hidden]="bulkUpdateCanceled">
            @if (!isBulkUpdateDone) {
                <h3 class="text-center">Bulk Updating</h3>
            }
            @if (isBulkUpdateDone) {
                <h3 class="text-center">Done</h3>
            }
            <progressbar class="active"
                         [class.progress-striped]="bulkUpdateCurrent.index < selectionsLength"
                         [max]="selectionsLength" [value]="bulkUpdateCurrent.index" type="info">
            </progressbar>
            @if (!isBulkUpdateDone) {
                <h3>{{ getCurrentBulkUpdateIdentity() }}</h3>
            }
        </div>
        <div [hidden]="!bulkUpdateCanceled">
            <h3 class="text-center">Canceled</h3>
        </div>
        <div style="margin-top: 10px; font-size: 16px">
            <table class="bulk-update-results">
                <tr>
                    <td>
                        <label>Rows Processed:</label>
                    </td>
                    <td></td>
                    <td>{{ bulkUpdateCurrent.index - 1 }}</td>
                </tr>
                @if (bulkUpdateTotals.rowsChanged !== null) {
                    <tr>
                        <td>
                            <label>Rows Changed:</label>
                        </td>
                        <td></td>
                        <td>{{ bulkUpdateTotals.rowsChanged }}</td>
                    </tr>
                }
                @if (bulkUpdateTotals.billsChanged !== null) {
                    <tr>
                        <td>
                            <label>Bills Changed:</label>
                        </td>
                        <td></td>
                        <td>{{ bulkUpdateTotals.billsChanged }}</td>
                    </tr>
                }
            </table>
        </div>
        <div class="text-center" style="margin-top: 20px;">
            @if (bulkUpdateCanceled || isBulkUpdateDone) {
                <button class="ace-btn btn-primary"
                        (click)="endBulkUpdate.emit()">OK
                </button>
            }
            @if (!bulkUpdateCanceled && !isBulkUpdateDone) {
                <button class="ace-btn btn-primary btn-danger"
                        (click)="bulkUpdateCanceled = true">Cancel
                </button>
            }
        </div>
    </div>